import { useServices } from "@/services-context";
import { HomePageDesktop } from "./home-page-desktop";
import { HomePageMobile } from "./home-page-mobile";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { Services } from "@/services/services";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";
import { Url } from "@/helpers/url.ts";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";
import { defaultLang } from "@/constants/languages.ts";
import { CUSTOMER_CHANNEL_LISTENER_NAME } from "@/services/customer-channel.ts";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });

  const registryUrl = Url.normalizeRoute(route.path);
  const alternates = await services.routes.resolveAlternates(registryUrl);

  const canonical = !registryUrl ? `/${defaultLang}/` : registryUrl;

  return {
    type: "static",
    canonical: canonical,
    alternates: alternates,
  };
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return HomePageDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return HomePageMobile;
  }
};

export const HomePage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices([CUSTOMER_CHANNEL_LISTENER_NAME]);
  const { layoutType } = useLayoutType();

  const seoMarkupDataset = useSuspenseLoader({
    key: "home-route",
    loader: () =>
      fetchPageData({
        services: services,
        location: location,
        route: route,
      }),
  }) as SeoMarkupDataset;

  const PageComponent = getPageComponent(layoutType);

  return (
    <div style={{ display: "contents" }}>
      <PageComponent />
      <PageTags seo={seoMarkupDataset} />
    </div>
  );
});
